module.exports = __webpack_public_path__ + "f25dd7cf4d3caf9bcb46e02ca615803d.png";